

import React, { useState, useEffect } from 'react';
import { GridContainer } from '../../global';
import { BlogBanner, BlogCard, BlogGrid, CardContent } from './style';


const SPACE_ID = 'js0jco2wnv88';
const ACCESS_TOKEN = '7iNOSfMbMjQFx6ffcZmKI8iuXt9CWsWkYfK5PrqifoE';

function Blog() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const url = `https://cdn.contentful.com/spaces/${SPACE_ID}/environments/master/entries?access_token=${ACCESS_TOKEN}&content_type=post`;

        fetch(url)
            .then(response => response.json())
            .then(data => {
               
                const linkedAssets = data.includes?.Asset || [];

                const allPosts = data.items
                    .map(post => {
                        
                        if (post.fields.imagemDestacada?.sys?.id) {
                            const imageId = post.fields.imagemDestacada.sys.id;
                            const imageData = linkedAssets.find(asset => asset.sys.id === imageId);
                            
                        
                            if (imageData?.fields?.file?.url) {
                                return {
                                    ...post,
                                    imageUrl: 'https:' + imageData.fields.file.url
                                };
                            }
                        }
                        
                       
                        return null;
                    })
                    .filter(post => post !== null); 

                setPosts(allPosts);
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar posts:", error);
                setLoading(false);
            });
    }, []);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('pt-BR', options);
    };

    return (
        <div>
            <BlogBanner>
                <h1>Blog</h1>
                <p>Fique por dentro de tudo o que está acontecendo no mercado de energia solar!</p>
            </BlogBanner>
            
            <GridContainer>
                {loading ? (
                    <p style={{textAlign: "center", padding: "50px"}}>Carregando posts...</p>
                ) : (
                    <BlogGrid>
                        {posts.map(post => (
                            <BlogCard key={post.sys.id} to={`/blog/${post.fields.slug}`} state={{ allPosts: posts }}>
                                <img 
                                    src={post.imageUrl} 
                                    alt={post.fields.titulo} 
                                />
                                <CardContent>
                                    <h3>{post.fields.titulo}</h3>
                                    <p>{post.fields.resumo}</p>
                                    <span>Publicado em {formatDate(post.fields.dataDePublicao)}</span>
                                </CardContent>
                            </BlogCard>
                        ))}
                    </BlogGrid>
                )}
            </GridContainer>
        </div>
    );
}

export default Blog;